import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import { useCompletionAssignmentStore } from "%/dynamic-component-editor/stores/completion-assignment-store";
import { useCompletionStatusStore } from "%/dynamic-component-editor/stores/completion-status-store";

export const CompletionTrackingGateMixin = {
  computed: {
    completionTrackingPublicationId() {
      return useConfigurationStore().publicationId;
    },
    completionTrackingEnabled() {
      if (this.editMode) {
        return true;
      }
      if (!useCompletionStatusStore().hasSignedInUser) {
        return false;
      }
      return useCompletionAssignmentStore().isTrackingConfigured(this.completionTrackingPublicationId);
    },
    completionTwoStateMode() {
      return useCompletionAssignmentStore().isTwoStateMode(this.completionTrackingPublicationId);
    },
    shouldRenderButton() {
      // A folder's completion is derived from its children, not manually set — never
      // render a manual control for one (editMode keeps it selectable on the canvas).
      return this.completionTrackingEnabled && (this.editMode || !this.entity?.isFolder);
    },
  },
  watch: {
    completionTrackingPublicationId: {
      immediate: true,
      handler(publicationId) {
        if (!this.editMode && publicationId) {
          useCompletionAssignmentStore().ensureAssignments(publicationId);
          useCompletionAssignmentStore().ensureTwoStateMode(publicationId);
        }
      },
    },
  },
};
